import React, { type MouseEvent } from 'react';
import { xcss } from '@atlaskit/primitives';
import Anchor from '@atlaskit/primitives/anchor';
import { useIntl } from '@atlassian/jira-intl';
import type { BoardIssue } from '../../../../../common/types.tsx';
import messages from './messages.tsx';

type Props = {
	issue: BoardIssue;
	onClick: (arg1: MouseEvent<HTMLElement>) => void;
};

export const InteractionLayer = ({ issue, onClick }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Anchor
			aria-label={formatMessage(messages.interactionLayerLabel, {
				issueKey: issue.fields.issuekey.value,
				issueSummary: issue.fields.summary.value,
			})}
			draggable={false}
			href={`/browse/${issue.fields.issuekey.value}`}
			onClick={(event: MouseEvent<HTMLElement>) => {
				event.preventDefault();
				onClick(event);
			}}
			xcss={interactionLayerStyles}
		/>
	);
};

const interactionLayerStyles = xcss({
	pointerEvents: 'auto',
	position: 'absolute',
	inset: '0',
	borderRadius: 'border.radius',
	':focus': {
		// @ts-expect-error no available token for -1px but it's the desired value
		outlineOffset: '-1px',
	},
	':focus-visible': {
		// @ts-expect-error no available token for -1px but it's the desired value
		outlineOffset: '-1px',
	},
	':focus-within': {
		// @ts-expect-error no available token for -1px but it's the desired value
		outlineOffset: '-1px',
	},
});
